import { API } from "./api";

export const addCampaign = (campaigns) => API.post(`/campaigns`, campaigns);
export const getCampaignsByCompany = (companyId) =>
  API.get(`/campaigns/company/${companyId}`);

export const getCampaignById = (campaignId) =>
  API.get(`campaigns/${campaignId}`);

export const updateCampaign = (campaignId, campaign) =>
  API.put(`/campaigns/${campaignId}`, campaign);

export const deleteCampaign = (campaignId) =>
  API.delete(`/campaigns/${campaignId}`);

export const screensAvailable = (availableScreen) =>
  API.post(`/campaigns/screens-available`, availableScreen);
